export default __webpack_public_path__ + "static/media/vehicle-not-available.6eff8e72.webp";